import { conLanding } from "../../Panel/Models/Landing";
import { Programas as c } from "../Custom/Programas";

export default class Programas extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}